import { useEffect, useRef, useState } from "react";
import mainLogo from "../../assets/watermark-imge.png"

const ImageWithWatermark = ({ isViewerOpen, tagetImage, closeImageViewer }) => {
  const imageRef = useRef(null);
  const [imageWidth, setImageWidth] = useState(0);
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageLoad = () => {
    if (imageRef.current) {
      setImageWidth(imageRef.current.clientWidth);
      setImageLoaded(true);
    }
  };

  return (
    isViewerOpen && (
      <div
        className="fixed inset-0 z-[9999] bg-black/90 flex items-center justify-center"
        onContextMenu={(e) => e.preventDefault()}
      >
        <div className="relative inline-block">
          {/* Main Image */}
          <img
            ref={imageRef}
            src={tagetImage}
            alt="Original"
            className="max-h-[90vh] max-w-[90vw] object-contain"
            onLoad={handleImageLoad}
          />

          {/* Watermark: only show when image is loaded */}
          {imageLoaded && (
            <img
              src={mainLogo}
              alt="Watermark"
              className="absolute top-1/2 left-1/2 pointer-events-none"
              style={{
                width: `${imageWidth * 0.9}px`,
                transform: "translate(-50%, -50%)",
              }}
            />
          )}
        </div>

        {/* Close button */}
        <button
          onClick={closeImageViewer}
          className="absolute top-4 right-4 text-white text-2xl"
        >
          ✕
        </button>
      </div>
    )
  );
};

export default ImageWithWatermark;